import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { defaultMST3020_R01DetailDto, defaultMST3020_R01HeaderDto, MST3020_R01DetailDto, MST3020_R01HeaderDto } from "./Dto_MST3020_R01";
import { useMST3020_R01Store } from "./Store_MST3020_R01";
import { DetailTable_MST3020_R01 } from "./DetailTable_MST3020_R01";
import { AgGridReact } from "ag-grid-react";
import { formatDate } from "src/utils/string/stringUtil";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { ImageForm } from "src/components/common/form/ImageForm";



interface Props {
	gridRef: React.RefObject<AgGridReact<MST3020_R01DetailDto> | null>;
}

export const Info_MST3020_R01 = (props: Props) => {

	const { gridRef } = props;

	// 
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { 
		editMST3020_R01Detail, setEditMST3020_R01Detail,
		deletedMST3020_R01DetailList,
	} = useMST3020_R01Store();

	
	const itemImageWrapperStyle = {
		wrapperStyle: "w-[400px] h-[250px]",
	}

	return (
		// <div className="w-full h-full flex flex-col gap-[4px]" ref={containerRef}>
		<div className="w-full h-full flex flex-col gap-[4px]">
			
			<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				
				<div className="w-full h-full flex flex-wrap gap-[12px] pt-[12px]">
					공정명 : {editMST3020_R01Detail?.workplaceNm}<br />
					입고창고명 : {editMST3020_R01Detail?.warehouseNm}
					<BRDiv />
					{/* deletedMST3020_R01DetailList : {JSON.stringify(deletedMST3020_R01DetailList)}<BRDiv /> */}
					<ImageForm title="작업표준서1" image={editMST3020_R01Detail?.standardSheet || ''} onImageChange={(standardSheet) => setEditMST3020_R01Detail({ ...(editMST3020_R01Detail ?? defaultMST3020_R01DetailDto), standardSheet,  })} wrapperOption={itemImageWrapperStyle} />
					<ImageForm title="작업표준서2" image={editMST3020_R01Detail?.standardSheet2 || ''} onImageChange={(standardSheet2) => setEditMST3020_R01Detail({ ...(editMST3020_R01Detail ?? defaultMST3020_R01DetailDto), standardSheet2 })} wrapperOption={itemImageWrapperStyle} />
					{/* <pre>
						editMST3020_R01Detail : { JSON.stringify({
							valueIndex: editMST3020_R01Detail?.valueIndex,
							workplaceCd: editMST3020_R01Detail?.workplaceCd,
							workplaceNm: editMST3020_R01Detail?.workplaceNm,
							warehouseCd: editMST3020_R01Detail?.warehouseCd,
							warehouseNm: editMST3020_R01Detail?.warehouseNm,
							standardSheet: editMST3020_R01Detail?.standardSheet.substring(0, 10),
							standardSheet2: editMST3020_R01Detail?.standardSheet2.substring(0, 10),
						}, null, 2)}
					</pre> */}
				</div>
			</div>
		</div>
	)
}